export default __webpack_public_path__ + "static/media/Rectangle_13.374987b4.png";